import { Drawer } from "antd";
import styled from "styled-components";

export const StyledDrawer = styled(Drawer)`
  position: relative;

  .ant-drawer-header {
    display: none;
  }
`;
